var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement, state } from "lit/decorators.js";
import { Event as AppEvent } from "../models/enums.js";
import { DataStore, Router } from "../services/datastore.service.js";
import { EventBus } from "../services/eventbus.service.js";
let AppNav = class AppNav extends LitElement {
    constructor() {
        super();
        this.menuStatus = "";
        this.select = "";
        this.pathname = "";
        this.requestUpdateEvent = (_event) => {
            this.requestUpdate();
        };
        this.routerChangeEvent = () => {
            const pathParts = window.location.pathname.split('/');
            const select = pathParts.length > 2 && pathParts[1] === 'cards' ? pathParts[2] : "";
            if (select !== "" && select === this.select) {
                this.eventbus.dispatchEvent(AppEvent.Refresh);
            }
            this.select = select;
            this.pathname = window.location.pathname;
        };
        this.datastore = DataStore.getInstance();
        this.eventbus = EventBus.getInstance();
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener("popstate", this.routerChangeEvent);
        this.eventbus.addEventListener(AppEvent.RequestUpdate, this.requestUpdateEvent);
    }
    disconnectedCallback() {
        window.removeEventListener("popstate", this.routerChangeEvent);
        this.eventbus.removeEventListener(AppEvent.RequestUpdate, this.requestUpdateEvent);
        super.disconnectedCallback();
    }
    createRenderRoot() {
        return this;
    }
    menuToggle() {
        this.menuStatus = this.menuStatus === "" ? "is-active" : "";
    }
    menuClose(e) {
        if (e && e.currentTarget) {
            e.preventDefault();
            const href = e.currentTarget.getAttribute('href');
            if (href && href !== '#') {
                Router.go(href);
            }
        }
        this.menuStatus = "";
        const homeEl = document.getElementById("home");
        if (homeEl)
            homeEl.blur();
    }
    login() {
        this.menuClose();
    }
    logout() {
        this.menuClose();
        this.datastore.logoutUser();
    }
    render() {
        return html `
      <nav id="navbar" class="navbar is-fixed-top shadow-nav">
          <div class="container">
              <div class="navbar-brand">
                  <a href="${this.datastore.loggedIn ? '/cards/current' : './'}" id="home" @click="${this.menuClose}" class="navbar-item ${this.select === "current" ? "is-active" : ""}">
                      <figure class="image">
                          <img src="./assets/icons/transparent/ios/40.png" style="height:auto;width:auto;max-width:40px;max-height:40px;" />
                      </figure>
                  </a>
                  ${this.datastore.online === false ? html `
                  <div class="navbar-item">
                      <span class="icon is-medium has-text-danger blink"><i class="fas fa-wifi"></i></span>
                  </div>
                  ` : ""}
                  ${this.datastore.loggedIn ? html `
                  <a href="/cards/draft" @click="${this.menuClose}" class="navbar-item ${this.select === "draft" ? "is-active" : ""}">
                      <span class="icon is-medium"> <i class="fas fa-edit"></i></span>
                  </a>
                  <a href="/cards/out" @click="${this.menuClose}" class="navbar-item ${this.select === "out" ? "is-active" : ""}">
                      <span class="icon is-medium"> <i class="fas fa-paper-plane"></i></span>
                  </a>
                  <a href="/cards/in" @click="${this.menuClose}" class="navbar-item ${this.select === "in" ? "is-active" : ""}">
                      <span class="icon is-medium"> <i class="fas fa-inbox"></i></span>
                  </a>
                  <a href="/cards/archive" @click="${this.menuClose}" class="navbar-item ${this.select === "archive" ? "is-active" : ""}">
                      <span class="icon is-medium"> <i class="fas fa-archive"></i></span>
                  </a>
                  ` : ""}
                  <div id="toggle" @click="${this.menuToggle}" class="navbar-burger burger ${this.menuStatus}" data-target="navMenu">
                      <span></span>
                      <span></span>
                      <span></span>
                  </div>
              </div>
              <div class="navbar-menu ${this.menuStatus}" id="navMenu">
                  <div class="navbar-end">
                      ${this.datastore.loggedIn ? html `
                      <a href="/user" @click="${this.menuClose}" class="navbar-item ${this.pathname === "/user" ? "is-active" : ""}">
                          <span class="icon is-medium"> <i class="fas fa-user"></i> </span>
                          ${this.datastore.user?.firstname}
                      </a>
                      ${this.datastore.isAdmin
            ? html `
                      <a href="/admin" @click="${this.menuClose}" class="navbar-item ${this.pathname === "/admin" ? "is-active" : ""}">
                          <span class="icon is-medium"> <i class="fas fa-cog"></i> </span>
                          Admin
                      </a>
                      `
            : ""}
                      <a href="#" @click="${this.logout}" class="navbar-item">
                          <span class="icon is-medium"> <i class="fas fa-lock"></i></span>
                          Logout
                      </a>
                      ` : html `
                      <a href="./" @click="${this.menuClose}" class="navbar-item ${this.pathname === "/" ? "is-active" : ""}">
                          <span class="icon is-medium"> <i class="fas fa-home"></i></span>
                          Home
                      </a>
                      <a href="./p/about" @click="${this.menuClose}" class="navbar-item ${this.pathname === "/p/about" ? "is-active" : ""}">
                          <span class="icon is-medium"> <i class="fas fa-question-circle"></i></span>
                          About
                      </a>
                      <a href="/register" @click="${this.menuClose}" class="navbar-item ${this.pathname === "/register" ? "is-active" : ""}">
                          <span class="icon is-medium"> <i class="fas fa-user-plus"></i> </span>
                          Register
                      </a>
                      <a href="/cards/current" @click="${this.menuClose}" class="navbar-item ${this.pathname === "/login" ? "is-active" : ""}">
                          <span class="icon is-medium"> <i class="fas fa-unlock"></i> </span>
                          Login
                      </a>
                      `}
                  </div>
              </div>
          </div>
      </nav>
    `;
    }
};
__decorate([
    state()
], AppNav.prototype, "menuStatus", void 0);
__decorate([
    state()
], AppNav.prototype, "select", void 0);
__decorate([
    state()
], AppNav.prototype, "pathname", void 0);
AppNav = __decorate([
    customElement("app-nav")
], AppNav);
export { AppNav };
//# sourceMappingURL=nav.component.js.map